let suppressMobileDrawerClickUntil = 0;
document.addEventListener(
  'click',
  function (event) {
    if (
      event.target.closest('.mobile-quick-add-opener') ||
      event.target.closest('.desktop-quick-add-opener') ||
      event.target.closest('.mobile-size-drawer') ||
      event.target.closest('.desktop-size-drawer') ||
      event.target.closest('button')
    ) {
      return;
    }

    const clickedCardImage =
      event.target.closest('.card__media') ||
      event.target.closest('.card__media-link') ||
      event.target.closest('.media') ||
      event.target.closest('.card__inner');

    if (!clickedCardImage) return;

    const card = clickedCardImage.closest('.card-wrapper');
    if (!card) return;

    const productLink =
      card.querySelector('a[id^="CardLink-"][href]') ||
      card.querySelector('.card__heading a[href]');

    if (!productLink || !productLink.href) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.href = productLink.href;
  },
  true
);


function addQuickVariantToCart(variantId, triggerButton, afterAdd) {
  if (!variantId || triggerButton.dataset.adding === 'true') return;

  triggerButton.dataset.adding = 'true';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    })
    .then(function () {
      if (typeof afterAdd === 'function') afterAdd();

      return Promise.all([
        fetch('/cart?section_id=cart-drawer').then(function (response) {
          return response.text();
        }),
        fetch('/cart?section_id=cart-icon-bubble').then(function (response) {
          return response.text();
        }),
      ]);
    })
    .then(function (sections) {
      const cartDrawerHTML = sections[0];
      const cartBubbleHTML = sections[1];

      const currentCartDrawer = document.querySelector('cart-drawer');
      const parsedCartDrawer = new DOMParser().parseFromString(cartDrawerHTML, 'text/html');
      const newCartDrawer = parsedCartDrawer.querySelector('cart-drawer');

      if (currentCartDrawer && newCartDrawer) {
        currentCartDrawer.replaceWith(newCartDrawer);
      }

      const currentCartBubble = document.querySelector('#cart-icon-bubble');
      const parsedCartBubble = new DOMParser().parseFromString(cartBubbleHTML, 'text/html');
      const newCartBubble = parsedCartBubble.querySelector('#cart-icon-bubble');

      if (currentCartBubble && newCartBubble) {
        currentCartBubble.replaceWith(newCartBubble);
      }

      const refreshedCartDrawer = document.querySelector('cart-drawer');

      if (refreshedCartDrawer && typeof refreshedCartDrawer.open === 'function') {
        refreshedCartDrawer.open();
      }
    })
    .catch(function (error) {
      console.error(error);
    })
    .finally(function () {
      triggerButton.dataset.adding = 'false';
    });
}




document.addEventListener(
  'click',
  function (event) {
    if (Date.now() < suppressMobileDrawerClickUntil) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  },
  true
);

function getMobileQuickAddFromPoint(event) {
  const icons = document.querySelectorAll('[data-mobile-size-drawer]');

  for (const icon of icons) {
    const rect = icon.getBoundingClientRect();

    if (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    ) {
      return icon;
    }
  }

  return null;
}

function openMobileSizeDrawer(opener) {
  const drawer = document.getElementById(opener.dataset.mobileSizeDrawer);
  if (!drawer) return;

  document.body.appendChild(drawer);
  drawer.hidden = false;
  drawer.classList.add('is-open');
  document.body.classList.add('overflow-hidden');
}

function closeMobileSizeDrawer(drawer) {
  drawer.classList.remove('is-open');
  drawer.hidden = true;
  document.body.classList.remove('overflow-hidden');
}

document.addEventListener(
  'pointerup',
  function (event) {
    const mobileDirectButton = event.target.closest('[data-mobile-direct-variant-id]');

    if (mobileDirectButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      suppressMobileDrawerClickUntil = Date.now() + 600;

      addQuickVariantToCart(
        mobileDirectButton.dataset.mobileDirectVariantId,
        mobileDirectButton
      );

      return;
    }

    const opener =
      event.target.closest('[data-mobile-size-drawer]') ||
      getMobileQuickAddFromPoint(event);

    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      suppressMobileDrawerClickUntil = Date.now() + 600;

      openMobileSizeDrawer(opener);
      return;
    }

    const close = event.target.closest('[data-mobile-size-close]');

    if (close) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      suppressMobileDrawerClickUntil = Date.now() + 600;

      const drawer = close.closest('.mobile-size-drawer');
      if (drawer) closeMobileSizeDrawer(drawer);
      return;
    }

    const variantButton = event.target.closest('.mobile-size-drawer .variant-option');

    if (variantButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (variantButton.disabled) return;

      addQuickVariantToCart(
        variantButton.dataset.variantId,
        variantButton,
        function () {
          const drawer = variantButton.closest('.mobile-size-drawer');
          if (drawer) closeMobileSizeDrawer(drawer);
        }
      );
    }
  },
  true
);

function getDesktopSizeDrawerOpenerFromPoint(event) {
  if (!window.matchMedia('(min-width: 750px)').matches) return null;

  const openers = document.querySelectorAll('[data-desktop-size-drawer]');

  for (const opener of openers) {
    const rect = opener.getBoundingClientRect();

    if (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    ) {
      return opener;
    }
  }

  return null;
}

function openDesktopSizeDrawer(opener) {
  const drawer = document.getElementById(opener.dataset.desktopSizeDrawer);
  if (!drawer) return;

  document.body.appendChild(drawer);
  drawer.hidden = false;
  drawer.classList.add('is-open');
  document.body.classList.add('overflow-hidden');
}

function closeDesktopSizeDrawer(drawer) {
  drawer.classList.remove('is-open');
  drawer.hidden = true;
  document.body.classList.remove('overflow-hidden');
}

document.addEventListener(
  'click',
  function (event) {
    const desktopDirectButton = event.target.closest('[data-desktop-direct-variant-id]');

    if (desktopDirectButton && window.matchMedia('(min-width: 750px)').matches) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addQuickVariantToCart(
        desktopDirectButton.dataset.desktopDirectVariantId,
        desktopDirectButton
      );

      return;
    }

    const opener =
      event.target.closest('[data-desktop-size-drawer]') ||
      getDesktopSizeDrawerOpenerFromPoint(event);

    if (opener) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openDesktopSizeDrawer(opener);
      return;
    }

    const close = event.target.closest('[data-desktop-size-close]');

    if (close) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const drawer = close.closest('.desktop-size-drawer');
      if (drawer) closeDesktopSizeDrawer(drawer);
      return;
    }

    const variantButton = event.target.closest('.desktop-size-drawer .variant-option');

    if (variantButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (variantButton.disabled) return;

      addQuickVariantToCart(
        variantButton.dataset.variantId,
        variantButton,
        function () {
          const drawer = variantButton.closest('.desktop-size-drawer');
          if (drawer) closeDesktopSizeDrawer(drawer);
        }
      );
    }
  },
  true
);
